import type { CheckboxProps } from '@radix-ui/react-checkbox';
import type { FC, ReactNode } from 'react';
import * as RadixCheckbox from '@radix-ui/react-checkbox';
import { Flex, Icon } from '@ui';
import clsx from 'clsx';
import { motion } from 'framer-motion';
import { useId } from 'react';
import styles from './Checkbox.module.css';

type Props = {
    label?: ReactNode;
    error?: boolean;
} & Omit<CheckboxProps, 'className' | 'style' | 'title'>;

export const Checkbox: FC<Props> = ({ label, error, ...props }) => {
    const labelId = useId();

    const checkbox = (
        <RadixCheckbox.Root
            asChild
            id={label ? labelId : undefined}
            className={clsx(styles.checkbox, error && styles.error)}
            {...props}
        >
            <motion.button
                initial={{ scale: 1 }}
                whileHover={{ scale: (!props.disabled ? 1.05 : 1) }}
                whileTap={{ scale: 0.9 }}
                transition={{
                    type: 'spring',
                    stiffness: 1000,
                    damping: 30
                }}
            >
                <RadixCheckbox.Indicator asChild className={styles.indicator}>
                    <motion.div
                        initial={{ scaleX: 0, y: -5 }}
                        animate={{ scaleX: 1, y: 0 }}
                        transition={{
                            type: 'spring',
                            stiffness: 1000,
                            damping: 30
                        }}
                    >
                        <Icon.Check size={10} />
                    </motion.div>
                </RadixCheckbox.Indicator>
            </motion.button>
        </RadixCheckbox.Root>
    );

    if (!label)
        return checkbox;

    return (
        <Flex gap={12} align="center" className={styles.checkboxContainer}>
            {checkbox}
            <label htmlFor={labelId} className={styles.label}>{label}</label>
        </Flex>
    );
};
